<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form [formGroup]="supplierForm" (ngSubmit)="saveSupplier()" novalidate autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="off">
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-truck mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <label for="supplierName" class="block text-900 font-medium mb-2">Supplier Name</label>
          <input id="supplierName" type="text" pInputText formControlName="supplierName" class="w-full" />
          <small *ngIf="supplierForm.get('supplierName')?.invalid && supplierForm.get('supplierName')?.touched" class="p-error">
            Supplier Name is required.
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <label for="supplierNumber" class="block text-900 font-medium mb-2">Supplier Number</label>
          <input id="supplierNumber" type="text" pInputText formControlName="supplierNumber" class="w-full" />
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <p-button label="Cancel" styleClass="p-button-secondary" type="button" (onClick)="cancel()"></p-button>
      <p-button [label]="isEditMode ? 'Update Supplier' : 'Save Supplier'" type="submit" [disabled]="supplierForm.invalid"></p-button>
    </div>
  </form>
</div>
